export class TranslationId {
  static ENGLISH = 'EN';
  static CHINESE = 'CH';
  static KOREAN = 'KO';
  static JAPANESE = 'JP';
}
